import { FormEditActions } from "@arelia-components/form/FormEditActions";
import { Box, Button, Card, CardContent, CardHeader, IconButton, TextField } from "@mui/material";
import { FormikProps } from "formik";
import { ChangeEvent } from "react";
import { EditForm } from "./MembersContainer";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { useHandleFormActions } from "@arelia-hooks/formikHooks";
import MembersList from "./MembersList";

type Props = {
  formik: FormikProps<EditForm>;
  editing: boolean;
  setEditing: (editing: boolean) => void;
  removeMember: (index: number) => void;
  addMember: () => void;
  handeChange: (index: number, property: string) => (event: ChangeEvent<HTMLInputElement>) => void
};

export default function MembersPresenter({
  formik,
  editing,
  setEditing,
  handeChange,
  removeMember,
  addMember
}: Props) {
  const { handleSubmit, handleReset, handleEdit } = useHandleFormActions<EditForm>(setEditing, formik);

  const handleRemoveMember = (index: number) => removeMember(index);
  const handleAddMember = () => addMember();

  const members = formik.values.members;

  return (<Card sx={{
    gridColumn: "span 4",
    gridRow: "span 8",
    gap: "10px"
  }}>
    <CardHeader
      title="Members"
      action={<FormEditActions edit={editing} handleEdit={handleEdit} handleReset={handleReset} handleSubmit={handleSubmit} />}
    />
    <CardContent sx={{ justifyContent: "flex-start", gap: "5px", overflow: "auto" }}>
      {!editing &&
        <MembersList members={members}/>
      }
      {editing && members.map(({ name, role }, index) =>
        <Box sx={{ display: "flex", alignItems: "center", gap: "6px", paddingTop: "6px" }} key={index}>
          <TextField
            value={name || ""}
            onChange={handeChange(index, 'name')}
            size="small"
            label="Name"
            fullWidth
          />
          <TextField
            value={role || ""}
            onChange={handeChange(index, 'role')}
            label="Role"
            size="small"
            fullWidth
          />
          { index !== members.length &&
            <IconButton color="error" onClick={() => handleRemoveMember(index)}>
              <RemoveCircleOutlineOutlinedIcon />
            </IconButton>
          }
        </Box>
      )}
      {editing && <Button variant="text" startIcon={<AddOutlinedIcon />} onClick={() => handleAddMember()}>
        Add
      </Button>}
    </CardContent>
  </Card>)
}